module.exports = __webpack_public_path__ + "static/media/indian.2cececed.jpg";